<template>
  <div>
    <PCNavbar :selectIndex="3"/>
    <MobileNavBar :currentActive="3" />
    <CaseList />
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CaseList from '@/components/case/CaseList.vue'

export default {
  name: 'Case',
  components: {
    PCNavbar,
    MobileNavBar,
    CaseList
  }
}
</script>

<style>
</style>
